import React from "react";
import { CheckCircle2 } from "lucide-react";
import { CtaStrip } from "@/components/sections/HomeSections";
import SEO, { organizationSchema } from "@/components/SEO";

export default function About() {
  return (
    <div data-testid="about-page" className="pt-32">
      <SEO title="About Us" path="/about" description="Meet Elite Pixels — a small wedding photography and film team telling honest love stories with care, calm presence, and quiet attention to detail." jsonLd={organizationSchema()} />
      <section className="section-pad max-w-[1400px] mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="eyebrow">About Elite Pixels</div>
            <h1 className="font-serif text-5xl md:text-6xl font-light mt-4 tracking-tight leading-tight">
              Your Wedding Is More Than <em className="text-[#D4AF37] not-italic">A Day</em>
            </h1>
            <p className="mt-6 text-white/70 leading-relaxed">
              It is a story of love, family, and memories. Our purpose is to capture those moments
              honestly so you can relive them for years to come — and pass them on to the people
              who come after you.
            </p>
            <p className="mt-4 text-white/70 leading-relaxed">
              Elite Pixels is a small team led by Mujtaba Emal — a wedding photographer and filmmaker
              based in Toronto and travelling wherever your story unfolds. Over the past decade we've
              quietly stood beside couples in castles, vineyards, mountain tops, ballrooms, and beaches
              — from intimate elopements to celebrations of every culture and tradition.
            </p>
            <p className="mt-4 text-white/70 leading-relaxed">
              We aren't here to sell you on the biggest day of your life. We're here to listen,
              to understand what matters to you, and to capture it honestly.
            </p>
          </div>
          <img src="https://images.pexels.com/photos/31953126/pexels-photo-31953126.jpeg" alt="" className="w-full h-[600px] object-cover" />
        </div>

        <div className="mt-24 grid md:grid-cols-3 gap-8">
          {[
            ["Story First", "We listen before we shoot. The day belongs to you and the people in it."],
            ["Honest Frames", "Real moments, real emotion. No forced poses or empty smiles."],
            ["Made To Last", "Photographs and films edited so they'll feel right twenty years from now."],
          ].map(([t,d]) => (
            <div key={t} className="border border-white/10 bg-[#0a0a0a] p-8">
              <h3 className="font-serif text-2xl mb-3">{t}</h3>
              <p className="text-sm text-white/60 leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
      </section>
      <CtaStrip />
    </div>
  );
}
